import React from "react";
import { connect } from "react-redux";
import { useFormContext } from "react-hook-form";

import { PriceAndAreaIcon } from "../../../../assets";
import CurrencyDropdown from "../../../../layout/CurrencyDropdown";
import {
  areaMeasurmentOptions,
  EMPTY_STRING,
  DEFAULT_CURRENCY_ID,
} from "../../../../constants";
import CustomSelect from "../../../../shared/components/select/CustomSelect";

const PriceAndArea = (props) => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const selectedCurrency = watch("currencyId");

  const handleCurrencyChange = (currency) => {
    setValue("currencyId", currency);
  };

  return (
    <div className="create-form-card">
      <div className="form-card-heading">
        <img src={PriceAndAreaIcon} alt={EMPTY_STRING} />
        Price and Area
      </div>
      <div className="d-flex gap-3 area-fields-container">
        <input
          type="text"
          className={`create-list-input w-auto ${
            errors.area ? "border border-danger" : EMPTY_STRING
          }`}
          placeholder="Enter Area Size"
          name="area"
          {...register("area", { required: "Area size is required." })}
        />
        <CustomSelect
          options={areaMeasurmentOptions}
          className="w-50"
          name="areaMeasurementType"
          placeholder="Area"
          showError={false}
          isClearable={false}
          defaultStyle={false}
        />
      </div>
      <div className="price-field-container">
        <div className="d-flex column-gap-3 row-gap-2 flex-wrap">
          <input
            type="text"
            className={`create-list-input w-auto ${
              errors.price ? "border border-danger" : EMPTY_STRING
            }`}
            placeholder="Enter Price"
            name="price"
            {...register("price")}
          />
          <input
            type="text"
            className={`create-list-input w-auto ${
              errors.depositAmount ? "border border-danger" : EMPTY_STRING
            }`}
            placeholder="Enter Deposit Required"
            name="depositAmount"
            {...register("depositAmount")}
          />
          <CurrencyDropdown
            buttonClass="create-list-currency"
            allCurrencies={props.allCurrencies}
            className="create-list-input w-auto px-2 py-1"
            selectedCurrency={selectedCurrency ?? DEFAULT_CURRENCY_ID}
            onCurrencyChange={handleCurrencyChange}
          />
        </div>
      </div>
      <div className="instruction ms-0">
        *Our system validates the price. Please enter a realistic price for your
        property that is according to the market rates for the selected
        location.
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allCurrencies: state.homeReducer.allCurrencies,
});

export default connect(mapStateToProps, null)(PriceAndArea);
